import { Controller } from "@hotwired/stimulus"
import ClipboardJS from "clipboard"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    console.log("📋 ClipboardController connected")

    this.clipboard = new ClipboardJS(this.buttonTarget, {
      target: () => document.querySelector("#user-link")
    })

  this.clipboard.on("success", (e) => {
  e.clearSelection()

  const toast = document.createElement("div")
  toast.style.position = "fixed"
  toast.style.bottom = "20px"
  toast.style.right = "20px"
  toast.style.padding = "10px 15px"
  toast.style.background = "#333"
  toast.style.color = "#fff"
  toast.style.borderRadius = "8px"
  toast.style.display = "flex"
  toast.style.alignItems = "center"
  toast.style.gap = "0.5rem"
  toast.style.boxShadow = "0 2px 5px rgba(0,0,0,0.5)"
  toast.style.zIndex = "1000"

  toast.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 24 24">
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v16h14V5zm-2 14H10v-2h7v2zm0-4H10v-2h7v2zm0-4H10V9h7v2z"/>
    </svg>
    <span>Copied: ${e.text}</span>
  `

  document.body.appendChild(toast)

  window.SiteNotices.show(toast, { remove: true })
})

    this.clipboard.on("error", () => {
      alert("⚠️ Copy failed. Try manually.")
    })
  }

  disconnect() {
    if (this.clipboard) this.clipboard.destroy()
  }
}



